module.exports = __webpack_public_path__ + "img/value-absolute.abbcf397.svg";